<app-page inTutorial="true">
  <buy-deso-tutorial></buy-deso-tutorial>
</app-page>
